import { IsNotEmpty, IsString, Validate } from 'class-validator';

import PhoneNumberE164IsValid from 'src/models/validators/phoneNumberE164Validator';

export default class PhoneNumber {
  @IsString()
  @IsNotEmpty({ message: 'Phone should not be empty' })
  @Validate(PhoneNumberE164IsValid)
  phoneNumber: string;
}
